import { useEffect } from 'react';

const SUFFIX = ' | LMF';
const DEFAULT = 'LMF — Lithuanian Muaythai Federation';

type Part = string | false | null | undefined;

export function usePageTitle(parts: Part | Part[]) {
  const arr = Array.isArray(parts) ? parts : [parts];
  const key = arr.map(p => p ?? '').join('|');

  useEffect(() => {
    const filtered = arr.filter((p): p is string => Boolean(p));
    document.title = filtered.length ? filtered.join(' · ') + SUFFIX : DEFAULT;
    return () => { document.title = DEFAULT; };
    // arr identity changes every render but `key` is a faithful projection of its contents
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}
